import { render, staticRenderFns } from "./detail_suppliers_page.vue?vue&type=template&id=7e768b0c&scoped=true"
import script from "./detail_suppliers_page.vue?vue&type=script&lang=js"
export * from "./detail_suppliers_page.vue?vue&type=script&lang=js"
import style0 from "./detail_suppliers_page.vue?vue&type=style&index=0&id=7e768b0c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e768b0c",
  null
  
)

export default component.exports